// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NKfyg","col":"styles_col__3D_Zj"};